module.exports = __webpack_public_path__ + "img/377.5de8797a.png";